import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import colors from '@app/constants/colors';
import footerLinks from '@app/constants/footerLinks';

const Footer = ({ locale }) => (
  <FooterContainer>
    <SocialDownloadLinks>
      <SocialWrapper>
        <SocialTitle><FormattedMessage id="footer.followUs" /></SocialTitle>
        <SocialLinks>
          <li>
            <a href={footerLinks.socialLinks.facebook} target="_blank" rel="noopener noreferrer">
              <Image src="/images/logo-fb.png" alt="facebook" />
            </a>
          </li>
          <li>
            <a href={footerLinks.socialLinks.youtube} target="_blank" rel="noopener noreferrer">
              <Image src="/images/logo-yout.png" alt="youtube" />
            </a>
          </li>
          <li>
            <a href={footerLinks.socialLinks.instagram} target="_blank" rel="noopener noreferrer">
              <Image src="/images/logo-inst.png" alt="instagram" />
            </a>
          </li>
          <li>
            <a href={footerLinks.socialLinks.twitter} target="_blank" rel="noopener noreferrer">
              <Image src="/images/logo-tw.png" alt="twitter" />
            </a>
          </li>
        </SocialLinks>
      </SocialWrapper>
      <DonwloadWrapper>
        <a href={footerLinks.downloadLinks.appstore} target="_blank" rel="noopener noreferrer">
          <Image src="/images/appstore.png" alt="appstore" />
        </a>
        <a href={footerLinks.downloadLinks.googleplay} target="_blank" rel="noopener noreferrer">
          <Image src="/images/googleplay.png" alt="googleplay" />
        </a>
      </DonwloadWrapper>
    </SocialDownloadLinks>
    <InfoLinks>
      <a href={footerLinks.infoLinks.terms[locale]} target="_blank" rel="noopener noreferrer"><FormattedMessage id="footer.terms" /></a>
      <a href={footerLinks.infoLinks.policy[locale]} target="_blank" rel="noopener noreferrer"><FormattedMessage id="footer.policy" /></a>
      <a href={footerLinks.infoLinks.frequencies[locale]} target="_blank" rel="noopener noreferrer"><FormattedMessage id="footer.frequencies" /></a>
      <a href={footerLinks.infoLinks.help[locale]} target="_blank" rel="noopener noreferrer"><FormattedMessage id="footer.help" /></a>
      <a href={footerLinks.infoLinks.feedback[locale]} target="_blank" rel="noopener noreferrer"><FormattedMessage id="footer.feedback" /></a>
      <span><FormattedMessage id="footer.rights" /></span>
    </InfoLinks>
  </FooterContainer>
);

Footer.propTypes = {
  locale: PropTypes.string.isRequired,
};

const FooterContainer = styled.footer`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  padding: 40px 20px 30px;
  flex: 0 0 auto;
`;

const Image = styled.img`
  max-width: 100%;
  height: auto;
  margin: 0;
`;

const SocialDownloadLinks = styled.div`
  width: 100%;
  max-width: 1020px;
  margin: 0 auto 40px;
  display: flex;
  justify-content: space-between;
  & li {
    padding: 0 5px;
  }
  @media (max-width: 979px) {
    flex-direction: column;
    align-items: center;
    margin-bottom: 25px;
  }
`;

const SocialWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 979px) {
    width: 70%;
    margin-bottom: 20px;
  }
`;

const SocialTitle = styled.p`
  margin: 0;
  margin-bottom: 35px;
  text-align:  center;
`;

const SocialLinks = styled.ul`
  display: flex;
  margin: 0;
  padding: 0;
  list-style-type: none;
  justify-content: space-between;
  @media (max-width: 979px) {
    justify-content: center;
    & a {
      margin-right: 15px;
    }
  }
`;

const DonwloadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  & a:first-child {
    margin-bottom: 25px;
  }
  @media (max-width: 979px) {
    flex-direction: row;
    justify-content: center;
    width: 80%;
    & a:first-child {
      margin-bottom: 0;
      margin-right: 15px;
    }
  }
`;

const InfoLinks = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;
  justify-content: center;
  & a, & > span {
    font-size: 14px;
    line-height: 1.36;
    margin: 0 10px;
    color: ${colors.JACARTA}
  }
  & a:hover {
    text-decoration: underline;
  }
`;

const mapStateToProps = ({ intl }) => ({
  locale: intl.locale,
});

export default connect(mapStateToProps)(Footer);
